import { Dialog } from '@servicetitan/anvil2';
import { useState, useCallback } from 'react';
import { useBreakpoint } from '@servicetitan/financing-utils-shared';
import {
    SubmittingUser,
    ExternalApplicationResponse,
    LoanApplicationSubmitSource2,
} from '@servicetitan/financing-api-client';
import { LogService } from '@servicetitan/log-service';
import { FinancedAmountStore } from '@servicetitan/financing-plans-shared';
import { PrequalFlowRenderer } from './PrequalFlowRenderer';

interface PrequalContainerProps {
    onClose: () => void;
    allowSendViaEmail?: boolean;
    showTechnicianInstructions?: boolean;
    submittingUser?: SubmittingUser;
    source?: LoanApplicationSubmitSource2;
    onOpenApplication?: (response?: ExternalApplicationResponse) => void;
}

export const PrequalContainer = ({
    onClose,
    allowSendViaEmail = false,
    showTechnicianInstructions = false,
    submittingUser,
    source = LoanApplicationSubmitSource2.OnlineEstimates,
    onOpenApplication,
}: PrequalContainerProps) => {
    const [isOpen, setIsOpen] = useState(true);
    const screenSize = useBreakpoint();
    const { financedAmount } = FinancedAmountStore.useStore();
    const handleClose = useCallback(() => {
        if (isOpen) {
            setIsOpen(false);
            onClose();
        }
    }, [onClose, isOpen]);

    return (
        <LogService endpoint="/api/log" storageKey="LogStorage_PrequalificationFlow">
            <Dialog
                open={isOpen}
                size="large"
                fullScreen={screenSize.isSm || screenSize.isXs}
                onClose={handleClose}
                disableCloseOnClickOutside
            >
                <PrequalFlowRenderer
                    onClose={handleClose}
                    allowSendViaEmail={allowSendViaEmail}
                    showTechnicianInstructions={showTechnicianInstructions}
                    submittingUser={submittingUser}
                    source={source}
                    approvedAmount={financedAmount ?? 0}
                    onOpenApplication={onOpenApplication}
                />
            </Dialog>
        </LogService>
    );
};
